const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

if (isIE11) {
  // eslint-disable-next-line no-console
  console.log("IE11 Fixes loaded");

  document.body.classList.add("ie-11-fixes");
  // require wird statt import verwendet, da imports nicht an Bedingungen geknüpft werden können
  require("./scss/index.scss");
  require("blueimp-canvas-to-blob");
  require("ie11-custom-properties");
  require("whatwg-fetch");
}
